var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-container"},[_c('img',{staticStyle:{"width":"200px","height":"200px","position":"absolute","left":"42%","top":"42%"},attrs:{"src":_vm.imgsrc,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }